<ng-template #modal>
  <div class="modal-header">
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">{{ 'INVOICES.PICKER.TITLE'|translate }}</h4>
  </div>
  <div class="modal-body">

    <!-- Filtros -->
    <div class="row">
      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label">{{ 'GLOBAL.DUE_DATE'|translate }}</label>
          <div class="input-group">
            <div class="input-group-addon">
              <i class="material-symbols-rounded">date_range</i>
            </div>
            <input type="text" class="form-control" readonly
            placeholder="{{ 'GLOBAL.RANGE_PLACEHOLDER'|translate }}"
            bsDaterangepicker placement="bottom" container="body"
            [bsConfig]="{ adaptivePosition: true, showWeekNumbers: false, rangeInputFormat: 'DD/MM/YYYY' }"
            [(ngModel)]="dueDateRange" (ngModelChange)="onDueDateRangeChange()">
          </div>
          <p class="small no-margin">
            <button type="button" class="btn btn-xs" [class.btn-agree]="overdueOnly" [class.btn-default]="!overdueOnly"
            (click)="setOverdue()">{{ 'INVOICES.PICKER.OVERDUE'|translate }}</button>
            <button type="button" class="btn btn-xs" [class.btn-agree]="dueInDays === 7" [class.btn-default]="dueInDays !== 7"
            (click)="setDueInDays(7)">{{ 'INVOICES.PICKER.DUE_IN_DAYS'|translate:{days: 7} }}</button>
            <button type="button" class="btn btn-xs" [class.btn-agree]="dueInDays === 30" [class.btn-default]="dueInDays !== 30"
            (click)="setDueInDays(30)">{{ 'INVOICES.PICKER.DUE_IN_DAYS'|translate:{days: 30} }}</button>
          </p>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label">{{ 'INVOICES.PICKER.AMOUNT_RANGE'|translate }}</label>
          <div class="flex-center-distributed spaced">
            <input type="number" min="0" class="form-control" placeholder="{{ 'INVOICES.PICKER.AMOUNT_MIN'|translate }}"
            [(ngModel)]="balanceMin" (ngModelChange)="onFiltersChange()">
            <input type="number" min="0" class="form-control" placeholder="{{ 'INVOICES.PICKER.AMOUNT_MAX'|translate }}"
            [(ngModel)]="balanceMax" (ngModelChange)="onFiltersChange()">
          </div>
        </div>
      </div>
      <div class="col-sm-2">
        <div class="form-group">
          <label class="control-label">{{ 'GLOBAL.INVOICE_NUMBER'|translate }}</label>
          <input type="text" class="form-control" placeholder="0000-00000000"
          [(ngModel)]="reference" (ngModelChange)="onFiltersChange()">
        </div>
      </div>
      <div class="col-sm-2">
        <div class="form-group">
          <label class="control-label">{{ 'GLOBAL.ISSUED_BY'|translate }}</label>
          <input type="text" class="form-control" disabled [ngModel]="company?.name">
        </div>
      </div>
      <div class="col-sm-2">
        <div class="form-group">
          <label class="control-label">{{ 'GLOBAL.RECEIVER'|translate }}</label>
          <input type="text" class="form-control" [disabled]="!!recipient"
          [ngModel]="recipient ? recipient.name : recipientName" (ngModelChange)="recipientName = $event; onFiltersChange()">
        </div>
      </div>
    </div>
    <p class="text-right">
      <a class="small" (click)="clearFilters()">{{ 'FILTERS.CLEAR'|translate }}</a>
    </p>

    <!-- Resultados -->
    <div *ngIf="invoices; else loadingTemplate">
      <div class="horizontal-scroller" *ngIf="invoices.length > 0; else noData">
        <table class="table table-condensed table-hover no-margin">
          <thead>
            <tr class="tr-align-center">
              <th class="sap micro"></th>
              <th class="sap sortable" (click)="sort('date')">{{ 'GLOBAL.ISSUED'|translate }}</th>
              <th class="sap sortable" (click)="sort('reference')">{{ 'GLOBAL.INVOICE_NUMBER'|translate }}</th>
              <th class="hidden-xs">{{ 'GLOBAL.ISSUED_BY'|translate }}</th>
              <th class="hidden-xs">{{ 'GLOBAL.RECEIVER'|translate }}</th>
              <th class="sap sortable" (click)="sort('due_date')">
                <abbr title tooltip="{{ 'GLOBAL.DUE_DATE'|translate }}" [adaptivePosition]="false">{{ 'GLOBAL.DUE_DATE_ABBR'|translate }}</abbr>
              </th>
              <th class="sap text-right sortable" (click)="sort('balance')">{{ 'GLOBAL.TOTAL'|translate }}</th>
              <th class="sap text-right">{{ 'DASHBOARDS.PENDING'|translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="tr-align-center" *ngFor="let invoice of invoices"
            [class.disabled]="isExcluded(invoice)"
            [class.selected]="isSelected(invoice)"
            (click)="toggle(invoice)">
              <td class="sap micro">
                <input type="checkbox" class="no-margin"
                [checked]="isExcluded(invoice) || isSelected(invoice)"
                [disabled]="isExcluded(invoice) || (!isSelected(invoice) && maxReached)"
                (click)="$event.stopPropagation(); toggle(invoice)">
              </td>
              <td class="sap small">
                <ag-timestamp [date]="invoice.date" [showTime]="false"></ag-timestamp>
              </td>
              <td class="sap small"><samp>{{ invoice.reference|mask: '0000-00000000' }}</samp></td>
              <td class="hidden-xs"><company-info [company]="invoice.company" [activity]="false" [compact]="true"></company-info></td>
              <td class="hidden-xs"><company-info [company]="invoice.recipient" [activity]="false" [compact]="true"></company-info></td>
              <td class="sap small text-muted"><date-md [date]="invoice.due_date" [style]="true"></date-md></td>
              <td class="sap text-right"><price [unit]="invoice.unit.name" [value]="invoice.balance"></price></td>
              <td class="sap text-right text-muted">
                <price [unit]="invoice.unit.name" [value]="invoice.balance - (invoice.settled || 0)"></price>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="text-center" *ngIf="invoices.length > 0 && pagination?.total > invoices.length">
        <a [class.disabled]="loading" (click)="loadMore()">{{ 'INVOICES.PICKER.LOAD_MORE'|translate:{shown: invoices.length, total: pagination.total} }}</a>
      </p>
      <p class="text-muted small" *ngIf="maxReached">
        {{ 'INVOICES.PICKER.MAX_REACHED'|translate:{max: maxItems} }}
      </p>
    </div>
  </div>
  <div class="modal-footer flex-center-distributed">
    <span class="text-muted small">
      {{ 'INVOICES.PICKER.SELECTED_COUNT'|translate:{count: selected.length} }}
      <ng-container *ngIf="selected.length > 0">
        &mdash; <price [unit]="selected[0].unit.name" [value]="selectedBalance"></price>
      </ng-container>
    </span>
    <span>
      <button (click)="closeModal()" type="button" class="btn btn-link" data-dismiss="modal">
        {{ 'GLOBAL.CANCEL'|translate }}
      </button>
      <button type="button" (click)="confirm()" class="btn btn-agree" [disabled]="selected.length === 0">
        {{ 'INVOICES.PICKER.ADD'|translate }}
      </button>
    </span>
  </div>
</ng-template>

<ng-template #loadingTemplate>
  <div class="loading">
    <spinner message="{{ 'GLOBAL.LOADING'|translate }}"></spinner>
  </div>
</ng-template>

<ng-template #noData>
  <div class="no-data">
    <i class="material-symbols-rounded">block</i>
    {{ 'INVOICES.NO_DATA'|translate }}
  </div>
</ng-template>
